import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconArrowDown = forwardRef<SVGSVGElement, IconProps>(
  function IconArrowDown(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-8 h-8 flex-shrink-0 fill-current transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3484 4.64136C15.5465 4.83377 15.5511 5.15032 15.3586 5.34839L8.55864 12.3484C8.46622 12.4435 8.33977 12.4981 8.20714 12.4999C8.07451 12.5018 7.94657 12.451 7.85146 12.3585L0.651461 5.3585C0.453468 5.166 0.44901 4.84945 0.641503 4.65146C0.833996 4.45347 1.15055 4.44901 1.34854 4.6415L8.1899 11.2928L14.6414 4.65161C14.8338 4.45354 15.1503 4.44895 15.3484 4.64136Z"
        />
      </svg>
    )
  },
)
